import { createSlice } from "@reduxjs/toolkit";

import { fetchCaptureNotifications } from "./actions";

const DEFAULT_ERROR = "Failed to load notifications";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const captureNotificationsWidgetSlice = createSlice({
  name: "captureNotificationsWidget",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCaptureNotifications.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCaptureNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchCaptureNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default captureNotificationsWidgetSlice.reducer;
